import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import BlogBox from './BlogBox';
import Perspiciatis from './Perspiciatis';
import Gallery from './Gallery';

const BlogDetailContainer = () => {
  return (
    <Container fluid={true} className='blog-page'>
      <Breadcrumbs pageTitle='Blog Details' parent='Blog' title='Blog Details' />
      <Row>
        <BlogBox />
        <Col xxl='6' className='set-col-12 box-col-50 xl-60'>
          <Perspiciatis />
        </Col>
        <Gallery />
      </Row>
    </Container>
  );
};
export default BlogDetailContainer;
